const HomeView = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/HomeView.vue");
const PlansView = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/PlansView.vue");
const ContactView = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/ContactView.vue");
const WhoWeAreView = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/WhoWeAreView.vue");

const ComplaintChannelView = () =>
  import(/* webpackChunkName: "channels" */ "../views/ComplaintChannelView.vue");
const CipaComplaintChannelView = () =>
  import(/* webpackChunkName: "channels" */ "../views/CipaComplaintChannelView.vue");
const OmbudsmanChannelView = () =>
  import(/* webpackChunkName: "channels" */ "../views/OmbudsmanChannelView.vue");
const GdprChannelView = () =>
  import(/* webpackChunkName: "channels" */ "../views/GdprChannelView.vue");

const CompaniesView = () =>
  import(
    /* webpackChunkName: "empresas" */ "../views/companies/CompaniesView.vue"
  );
const CompaniesIdView = () =>
  import(
    /* webpackChunkName: "empresas" */ "../views/companies/CompaniesIdView.vue"
  );
const EmailSendedView = () =>
  import(/* webpackChunkName: "email" */ "../views/EmailSendedView.vue");
const SellView = () =>
  import(/* webpackChunkName: "email" */ "../views/SellView.vue");

const EBookView = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/EBookView.vue");

const PoliciesTermsContractsView = () =>
  import(/* webpackChunkName: "politica" */ "../views/PoliciesTermsContractsView.vue");

const StandardServiceContractView = () =>
  import(/* webpackChunkName: "politica" */ "../views/StandardServiceContractView.vue");

const DataOperatorContractView = () =>
  import(/* webpackChunkName: "politica" */ "../views/DataOperatorContractView.vue");

const CommercialCookiePolicyView = () =>
  import(/* webpackChunkName: "politica" */ "../views/CommercialCookiePolicyView.vue");

const ClientPanelCookiePolicyView = () =>
  import(/* webpackChunkName: "politica" */ "../views/ClientPanelCookiePolicyView.vue");

const ClientComplaintChannelsCookiePolicyView = () =>
  import(/* webpackChunkName: "politica" */ "../views/ClientComplaintChannelsCookiePolicyView.vue");

const CommercialPrivacyPolicyView = () =>
  import(/* webpackChunkName: "politica" */ "../views/CommercialPrivacyPolicyView.vue");

const ClientPanelPrivacyPolicyView = () =>
  import(/* webpackChunkName: "politica" */ "../views/ClientPanelPrivacyPolicyView.vue");

const ClientComplaintChannelsPrivacyPolicyView = () =>
  import(/* webpackChunkName: "politica" */ "../views/ClientComplaintChannelsPrivacyPolicyView.vue");

const CommercialTermsOfUseView = () =>
  import(/* webpackChunkName: "politica" */ "../views/CommercialTermsOfUseView.vue");

const ClientPanelTermsOfUseView = () =>
  import(/* webpackChunkName: "politica" */ "../views/ClientPanelTermsOfUseView.vue");

const PaymentStep1 = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/PaymentStep1.vue");

const PaymentStep2 = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/PaymentStep2.vue");

const PaymentStep3 = () =>
  import(/* webpackChunkName: "bcompliance" */ "../views/PaymentStep3.vue");

export const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/planos",
    name: "planos",
    component: PlansView,
  },
  {
    path: "/contato",
    name: "contato",
    component: ContactView,
  },
  {
    path: "/quem-somos",
    name: "quem-somos",
    component: WhoWeAreView,
  },
  {
    path: "/empresas",
    name: "empresas",
    component: CompaniesView,
  },
  {
    path: "/empresas/:id",
    name: "empresas-id",
    component: CompaniesIdView,
    meta: { sitemap: { ignoreRoute: true } },
  },
  {
    path: "/email-enviado",
    name: "email-enviado",
    component: EmailSendedView,
  },
  {
    path: "/sucesso",
    name: "sucesso",
    component: SellView,
  },
  {
    path: "/pagamento/passo-1",
    name: "pagamento-passo-1",
    component: PaymentStep1,
  },
  {
    path: "/pagamento/passo-2",
    name: "pagamento-passo-2",
    component: PaymentStep2,
  },
  {
    path: "/pagamento/passo-3",
    name: "pagamento-passo-3",
    component: PaymentStep3,
  },
  {
    path: "/e-book",
    name: "e-book",
    component: EBookView,
  },
  {
    path: "/canal-de-denuncia",
    name: "canal-de-denuncia",
    component: ComplaintChannelView,
  },
  {
    path: "/canal-de-denuncia-cipa",
    name: "canal-de-denuncia-cipa",
    component: CipaComplaintChannelView,
  },
  {
    path: "/canal-de-ouvidoria",
    name: "canal-de-ouvidoria",
    component: OmbudsmanChannelView,
  },
  {
    path: "/canal-lgpd",
    name: "canal-lgpd",
    component: GdprChannelView,
  },
  {
    path: "/politicas-termos-e-contratos",
    name: "politicas-termos-e-contratos",
    component: PoliciesTermsContractsView,
  },
  {
    path: "/contrato-padrao-de-prestacao-de-servicos",
    name: "contrato-padrao-de-prestacao-de-servicos",
    component: StandardServiceContractView,
  },
  {
    path: "/contrato-padrao-de-operador-de-dados",
    name: "contrato-padrao-de-operador-de-dados",
    component: DataOperatorContractView,
  },
  {
    path: "/politica-de-cookies-das-paginas-comerciais",
    name: "politica-de-cookies-das-paginas-comerciais",
    component: CommercialCookiePolicyView,
  },
  {
    path: "/politica-de-cookies-do-painel-do-cliente",
    name: "politica-de-cookies-do-painel-do-cliente",
    component: ClientPanelCookiePolicyView,
  },
  {
    path: "/politica-de-cookies-dos-canais-de-denuncias-dos-clientes",
    name: "politica-de-cookies-dos-canais-de-denuncias-dos-clientes",
    component: ClientComplaintChannelsCookiePolicyView,
  },
  {
    path: "/politica-de-privacidade-das-paginas-comerciais",
    name: "politica-de-privacidade-das-paginas-comerciais",
    component: CommercialPrivacyPolicyView,
  },
  {
    path: "/politica-de-privacidade-do-painel-do-cliente",
    name: "politica-de-privacidade-do-painel-do-cliente",
    component: ClientPanelPrivacyPolicyView,
  },
  {
    path: "/politica-de-privacidade-dos-canais-de-denuncias-dos-clientes",
    name: "politica-de-privacidade-dos-canais-de-denuncias-dos-clientes",
    component: ClientComplaintChannelsPrivacyPolicyView,
  },
  {
    path: "/termos-de-uso-das-paginas-comerciais",
    name: "termos-de-uso-das-paginas-comerciais",
    component: CommercialTermsOfUseView,
  },
  {
    path: "/termos-de-uso-do-painel-do-cliente",
    name: "termos-de-uso-do-painel-do-cliente",
    component: ClientPanelTermsOfUseView,
  },
];
